import styled from 'styled-components';

import { Text } from '@/nova/components';
import { SPACE } from '../../../../../../theme/tokens';
import { FINISH } from '../../finish.tokens';

/** Its own billing line under the setup fee: plain text in the success green (no pill). The
 *  horizontal padding matches the billing rows' 8px so the text lines up with their labels. */
export const Line = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  padding: ${SPACE[4]} ${SPACE[8]};
  color: ${FINISH.rowSublabelSuccess};
`;

/** Thin-stroked infinity mark (the font's ∞ glyph reads too heavy next to the label). */
export const Mark = styled.svg`
  flex-shrink: 0;
  width: 18px;
  height: 9px;
`;

export const Label = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
`;
